"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var useClickOutside = function useClickOutside(handler) {
  var node = (0, _react.useRef)();
  var clickHandler = (0, _react.useCallback)(function (e) {
    if (node && node.current && node.current.contains(e.target)) {
      return;
    }

    handler(e);
  }, [handler]);
  (0, _react.useEffect)(function () {
    // add when mounted
    document.addEventListener('mousedown', clickHandler); // return function to be called when unmounted

    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [clickHandler]);
  return node;
};

var _default = useClickOutside;
exports.default = _default;